import { RequestService } from '../../../common/services/RequestService';
import { GET_REQUEST_VIEWS } from '../constants';

export const getRequestViews = payload => {
  return RequestService.get(GET_REQUEST_VIEWS);
};
